<template>
  <div class="inviteJoinToast-wrap">
    <div class="bg">
      <div class="title">
        <span class="avatar">{{ props.data.userName ? props.data.userName.substring(0,1) : "" }}</span>
        <span class="txt">
           {{ props.data.userName }} {{ $t("邀请您参加与真会议") }}
        </span>
      </div>
      <div class="list">
        <div class="item">
          <span class="name">
            {{ $t("会议主题") }}
          </span>
          <span class="content">
            {{ props.data.name }}
          </span>
        </div>
        <div class="item">
          <span class="name">
            {{ $t("开始时间") }}
          </span>
          <span class="content">
            {{ returnDate(props.data.startTime) + " - " +  returnDate(props.data.endTime)}}
            {{ getTimezoneTxt(props.data.timeZone) }}
          </span>
        </div>
        <div class="item">
          <span class="name">
            {{ $t("会议室") }}
          </span>
          <span class="content">
            {{ $t("虚拟会议室") }}
          </span>
        </div>
      </div>
      <div class="intro">
<!--        <div class="intro-item">-->
<!--          <span class="name">-->
<!--            {{ $t("访客链接") }}-->
<!--          </span>-->
<!--          <span class="content chance">-->
<!--            {{ props.data.url }}-->
<!--          </span>-->
<!--          <div class="tips-wrap">-->
<!--            <img src="../../assets/img/icons/icon-tips.png" alt="" class="tips-btn">-->
<!--            <span class="tips">{{ $t("点击链接直接入会或添加至会议列表") }}</span>-->
<!--          </div>-->
<!--        </div>-->
        <div class="intro-item">
          <span class="name">
            {{ $t("会议号") }}
          </span>
          <span class="content chance2" @click="copy(props.data.virtual.virtualRoom)">
            {{ props.data.virtual.virtualRoom }}
          </span>
        </div>
        <div class="intro-item">
          <span class="name">
            {{ $t("主持密码") }}
          </span>
<!--          <span class="content chance2" @click="copy(props.data.virtual.virtualRoomPwd)">-->
          <span class="content chance2">
            {{ props.data.virtual.virtualRoomPwd }}
          </span>
          <div class="tips-wrap" @click="copyHref(props.data.virtual.virtualRoomPwd)">
            <img src="../../assets/img/icons/icon-tips.png" alt="" class="tips-btn">
            <span class="tips">{{ $t("复制主持人链接") }}</span>
          </div>
        </div>
        <div class="intro-item">
          <span class="name">
            {{ $t("访客密码") }}
          </span>
          <span class="content chance2">
            {{ props.data.virtual.virtualRoomVisitor }}
          </span>
          <div class="tips-wrap" @click="copyHref(props.data.virtual.virtualRoomVisitor)">
            <img src="../../assets/img/icons/icon-tips.png" alt="" class="tips-btn">
            <span class="tips">{{ $t("复制访客链接") }}</span>
          </div>
<!--          <div class="tips-wrap">-->
<!--            <img src="../../assets/img/icons/icon-tips.png" alt="" class="tips-btn">-->
<!--            <span class="tips">{{ $t("复制该信息，进入与真会议后即可加入") }}</span>-->
<!--          </div>-->
        </div>
        <div class="intro-item">
          <span class="name">
            {{ $t("SIP入会") }}
          </span>
          <span class="content chance2" >
            {{ props.data.virtual.virtualRoom }}@meetime.com
          </span>
        </div>
        <div class="intro-item">
          <span class="name">
            {{ $t("会议地点") }}
          </span>
          <span class="content chance2" >
            {{ props.data.roomName }}
          </span>
        </div>
        <div class="intro-item">
          <span class="name">
            {{ $t("与真空间") }}
          </span>
          <span class="content chance2" >
            {{ props.data.yuzhenRoomName }}
          </span>
        </div>
      </div>
      <div class="btn-list">
        <div class="btn" @click="copyCode">
          {{ $t("访客入会信息") }}
        </div>
        <div class="btn" @click="copyAll">
          {{ $t("主持入会信息") }}
        </div>
      </div>
      <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="store.dispatch('invite/closeToast')">
    </div>
  </div>
</template>

<script setup>
import useClipboard from 'vue-clipboard3';
import { useStore } from 'vuex';
import { alertCopyResult } from '../../composables/utils';
import {getCurrentInstance} from "vue";
import { getTimezoneTxt,timeZone } from "@/utils/constants";
// 多语言调用
const { appContext : { config: { globalProperties } } } = getCurrentInstance();

const store = useStore();

const props = defineProps({
  data: Object,
  index: Number,
});

/**
 * 主持链接
 */
function copyAll() {
  const obj = {
    title: props.data.name,
    startTime: returnDate(props.data.startTime) + " - " +  returnDate(props.data.endTime) + getTimezoneTxt(props.data.timeZone),
    meetingRoom: globalProperties.$t("虚拟会议室"),
    href: props.data.url.split("&")[0] + "&pin=" + props.data.virtual.virtualRoomPwd,
    code: props.data.virtual.virtualRoom,
    password: props.data.virtual.virtualRoomPwd,
    password1: props.data.virtual.virtualRoomVisitor,
    sip: props.data.virtual.virtualRoom + "@meetime.com",
    roomName: props.data.roomName,
    yuzhenRoomName: props.data.yuzhenRoomName,
  }
  copy(globalProperties.$t("会议主题") + `: ${obj.title}\n` +
      globalProperties.$t("开始时间") + `: ${obj.startTime}\n` +
      globalProperties.$t("会议室") + `: ${obj.meetingRoom}\n` +
      globalProperties.$t("会议链接") + `: ${obj.href}\n` +
      `(` + globalProperties.$t("推荐在浏览器中打开") + `)\n` +
      globalProperties.$t("会议号") + `: ${obj.code}\n` +
      globalProperties.$t("主持密码") + `: ${obj.password}\n` +
      globalProperties.$t("SIP入会") + `: ${obj.sip}\n` +
      globalProperties.$t("会议地点") + `: ${obj.roomName}\n` +
      globalProperties.$t("与真空间") + `: ${obj.yuzhenRoomName}\n`
  );
}

/**
 * 访客链接
 */
function copyCode() {
  const obj = {
    title: props.data.name,
    startTime: returnDate(props.data.startTime) + " - " +  returnDate(props.data.endTime) + getTimezoneTxt(props.data.timeZone),
    meetingRoom: globalProperties.$t("虚拟会议室"),
    href: props.data.url,
    code: props.data.virtual.virtualRoom,
    password: props.data.virtual.virtualRoomPwd,
    password1: props.data.virtual.virtualRoomVisitor,
    sip: props.data.virtual.virtualRoom + "@meetime.com",
    roomName: props.data.roomName,
    yuzhenRoomName: props.data.yuzhenRoomName,
  }
  copy(globalProperties.$t("会议主题") + `: ${obj.title}\n` +
      globalProperties.$t("开始时间") + `: ${obj.startTime}\n` +
      globalProperties.$t("会议室") + `: ${obj.meetingRoom}\n` +
      globalProperties.$t("访客链接") + `: ${obj.href}\n` +
      `(` + globalProperties.$t("推荐在浏览器中打开") + `)\n` +
      globalProperties.$t("会议号") + `: ${obj.code}\n` +
      globalProperties.$t("访客密码") + `: ${obj.password1}\n` +
      globalProperties.$t("SIP入会") + `: ${obj.sip}\n` +
      globalProperties.$t("会议地点") + `: ${obj.roomName}\n` +
      globalProperties.$t("与真空间") + `: ${obj.yuzhenRoomName}\n`
  );
}

// 复制链接
function copyHref(password){
  copy(props.data.url.split("&")[0] + "&pin=" + password)
}


// 点击粘贴
const { toClipboard } = useClipboard();
async function copy(text) {
  try {
    await toClipboard(text);
    alertCopyResult(globalProperties.$t("已复制"));
  } catch (e) {
    console.error(e);
  }
}

// 返回2023/08/31 14:00  类型日期
function returnDate(time){
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1 >= 10 ? new Date(time).getMonth() + 1 : "0" + ( new Date(time).getMonth() + 1)
  let date = new Date(time).getDate() >= 10 ? new Date(time).getDate() : "0" + new Date(time).getDate()
  let hour = new Date(time).getHours() >= 10 ? new Date(time).getHours() : "0" + new Date(time).getHours();
  let min = new Date(time).getMinutes() >= 10 ? new Date(time).getMinutes() : "0" + new Date(time).getMinutes();
  return year + "年" + month + "月" + date + "日 " + hour + ":" + min
}
</script>

<style lang="less" scoped>
.inviteJoinToast-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  z-index: 9999;

  .bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 52.70833vw;
    box-sizing: border-box;
    padding: 2.23958vw 3.33333vw 1.66666vw;
    border-radius: 0.83333vw;
    background: linear-gradient(to bottom, rgba(180, 29, 35, .1) 20%, #fff);
    background-size: 100% 7.8125vw;
    background-repeat: no-repeat;
    background-color: #fff;

    .title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 3.90625vw;

      .avatar {
        display: block;
        width: 3.33333vw;
        font-size: 1.45833vw;
        line-height: 3.33333vw;
        color: #fff;
        text-align: center;
        background: #B41D23;
        border-radius: 50%;
        margin-right: 1.66666vw;
        flex-shrink: 0;
      }

      .txt {
        display: block;
        font-size: 1.66666vw;
        line-height: 1;
        color: #B41D23;
      }
    }

    .list {
      width: 100%;

      .item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 1.25vw;

        .name {
          display: block;
          width: 3.75vw;
          font-size: 0.9375vw;
          line-height: 1;
          color: #8B8FA8;
          flex-shrink: 0;
          margin-right: 0.83333vw;
          text-align-last: justify;
        }

        .content {
          font-size: 0.83333vw;
          line-height: 1;
          color: #171A41;
        }
      }
    }

    .intro {
      //width: fit-content;
      background: #F5F5F7;
      border-radius: 0.20833vw;
      padding: 0.83333vw;
      margin-bottom: 3.33333vw;

      .intro-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 1.25vw;

        .name {
          display: block;
          width: 3.75vw;
          font-size: 0.9375vw;
          line-height: 1;
          color: #8B8FA8;
          flex-shrink: 0;
          margin-right: 0.83333vw;
          text-align-last: justify;
        }

        .content {
          display: block;
          font-size: 0.83333vw;
          line-height: 1;
          color: #171A41;
          margin-right: 0.83333vw;

          &.chance {
            color: #B41D23;
            text-decoration: underline;
            //cursor: pointer;
          }

          &.chance2 {
            //cursor: pointer;
          }
        }

        .tips-wrap {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;

          .tips-btn {
            width: 0.83333vw;
            margin-right: 0.41666vw;
          }

          .tips {
            font-size: 0.83333vw;
            line-height: 1;
            color: #8B8FA8;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .btn-list {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn {
        font-size: 0.83333vw;
        line-height: 2.8125vw;
        background: #B41D23;
        color: #fff;
        padding: 0 0.83333vw;
        border-radius: 0.41666vw;
        margin-left: 1.25vw;
        cursor: pointer;

        &:last-child {
          background: none;
          line-height: 2.70833vw;
          color: #B41D23;
          border: 0.05208vw solid #B41D23;
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .close {
      position: absolute;
      top: 2.5vw;
      right: 2.5vw;
      width: 1.66666vw;
      cursor: pointer;
    }

  }
}

@media screen and (max-width: 750px) {

  .inviteJoinToast-wrap {

    .bg {
      width: 90vw;
      padding: 4.8vw 5.33333vw 6.4vw;
      border-radius: 1.6vw;
      background-size: 100% 18vw;

      .title {
        margin-bottom: 10vw;

        .avatar {
          width: 8.53333vw;
          font-size: 3.73333vw;
          line-height: 8.53333vw;
          margin-right: 7.33333vw;
        }

        .txt {
          font-size: 4.26666vw;
        }
      }

      .list {

        .item {
          align-items: flex-start;
          margin-bottom: 3.2vw;

          .name {
            min-width: 14.93333vw;
            font-size: 3.73333vw;
            line-height: 4.26666vw;
            margin-right: 3.2vw;
          }

          .content {
            font-size: 3.73333vw;
            line-height: 4.26666vw;
          }
        }
      }

      .intro {
        width: 100%;
        box-sizing: border-box;
        border-radius: 1.06666vw;
        padding: 2.13333vw;
        margin-bottom: 3.33333vw;

        .intro-item {
          flex-wrap: wrap;
          margin-bottom: 3.2vw;

          .name {
            min-width: 14.93333vw;
            font-size: 3.73333vw;
            margin-right: 2.13333vw;
          }

          .content {
            font-size: 3.73333vw;
            margin-right: 2.13333vw;

            &.chance {
              color: #B41D23;
              text-decoration: underline;
              cursor: pointer;
            }

            &.chance2 {
              cursor: pointer;
            }
          }

          .tips-wrap {
            margin-left: calc(14.93333vw + 2.13333vw);
            margin-top: 1.33333vw;

            .tips-btn {
              width: 2.66666vw;
              margin-right: 1.06666vw;
            }

            .tips {
              font-size: 2.93333vw;
              line-height: 4vw;
            }
          }
        }
      }

      .btn-list {
        justify-content: space-between;

        .btn {
          font-size: 3.73333vw;
          line-height: 12.8vw;
          padding: 0 5.33333vw;
          border-radius: 1.6vw;

          &:last-child {
            line-height: 12.53333vw;
            border-width: 0.26666vw;
          }

        }
      }

      .close {
        top: 5.33333vw;
        right: 5.33333vw;
        width: 6.4vw;
      }

    }
  }

}
</style>
